<template>
	<div>
		<div>
			<vx-card title="Levertijden aanpassen">
				<div class="w-full vx-row">
					<div class="vx-col">
						Via onderstaande veld kun je de levertijd van al je producten in één keer aanpassen.
					</div>
				</div>
				<div class="w-full vx-row">
					<div class="vx-col w-full ">
						<label class="multiselect-label">Selecteer levertijd</label>
						<vue-multiselect
							label="name" placeholder="Selecteer levertijd" track-by="name"
							v-model="selectedDelivery"
							:options="deliveryOptions"
							:show-labels="false"
							:allow-empty="false"
						/>
						<br />
					</div>
				</div>
				<div class="w-full vx-row " v-if="!updatingDeliveryTime">
					<div class="vx-col w-full text-right">
						<vs-button type="border" @click.native="updateDelivery">Levertijd aanpassen</vs-button>
					</div>
					<div class="vx-col w-full text-right">
						<label class="text-sm">Voor alle producten</label>
					</div>
				</div>
				<div class="w-full vx-row" v-if="updatingDeliveryTime">
					<div class="vx-col w-full">
						<h5>Levertijd wordt aangepast voor {{ totalUpdates }} producten.</h5>
					</div>
					<div class="vx-col w-full">
						{{ updatingTotal }} / {{ totalUpdates }} verwerkt
						<vs-progress :height="12" :percent="this.updatePercentage" color="primary">Succes</vs-progress>
					</div>
				</div>
				<div v-if="this.updatedDeliveryTime.failed" class="vx-col w-full mt-5">
					<label>Levertijd aanpassen is mislukt voor {{ updatedDeliveryTime.failed }} producten</label>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';

export default {
	name: 'settings-deliverytime',
	data() {
		return {
			selectedDelivery: '',
			updatePercentage: 0,
			updatingDeliveryTime: false,
			updatedDeliveryTime: '',
			sendDelivery: {delivery_code: ''},
			totalUpdates: 0,
			updatingTotal: 0,
			deliveryOptions: [
				{
					name: 'Voor 23:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-23',
				},
				{
					name: 'Voor 22:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-22',
				},
				{
					name: 'Voor 21:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-21',
				},
				{
					name: 'Voor 20:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-20',
				},
				{
					name: 'Voor 19:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-19',
				},
				{
					name: 'Voor 18:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-18',
				},
				{
					name: 'Voor 17:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-17',
				},
				{
					name: 'Voor 16:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-16',
				},
				{
					name: 'Voor 15:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-15',
				},
				{
					name: 'Voor 14:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-14',
				},
				{
					name: 'Voor 13:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-13',
				},
				{
					name: 'Voor 12:00 besteld op werkdagen, de volgende dag in huis',
					toApi: '24uurs-12',
				},
				{
					name: '1 - 2 dagen',
					toApi: '1-2d',
				},
				{
					name: '2 - 3 dagen',
					toApi: '2-3d',
				},
				{
					name: '3 - 5 dagen',
					toApi: '3-5d',
				},
				{
					name: '4 - 8 dagen',
					toApi: '4-8d',
				},
				{
					name: '1 - 8 dagen',
					toApi: '1-8d',
				},
			],
		}
	},
	mounted() {
		this.statusUpdateDeliveryTime();
	},
	methods: {
		updateDelivery() {
			this.deliveryTimeSet = this.selectedDelivery.toApi;
			this.$store.dispatch('deliveryTime/updateDeliveryTimes', this.deliveryTimeSet).then(res => {
				this.statusUpdateDeliveryTime();
			}).catch(error => {
				this.$vs.notify({
					title: 'Error',
					text: 'Er is iets mis gegaan, probeer het opnieuw',
					color: 'danger'
				});
			});
		},
		statusUpdateDeliveryTime() {
			this.$store.dispatch('deliveryTime/getDeliveryStatus').then(res => {
				this.totalUpdates = this.$store.state.deliveryTime.deliveryUpdate.totalProducts;
				this.updatedDeliveryTime = this.$store.state.deliveryTime.deliveryUpdate;
				this.updatingTotal = this.updatedDeliveryTime.updated + this.updatedDeliveryTime.failed;
				this.updatePercentage = this.updatingTotal / this.updatedDeliveryTime.totalProducts * 100;
				if (this.updatedDeliveryTime.totalProducts !== this.updatingTotal) {
					this.updatingDeliveryTime = true;
					setTimeout(this.statusUpdateDeliveryTime, 3000);
				} else if (this.updatingDeliveryTime === true) {
					this.updatingDeliveryTime = false;
					this.createNotifySucces();

				}
			})
		},
		createNotifySucces() {
			this.$vs.notify({
				color: 'success',
				title: 'Levertijd verwerkt',
				text: 'De levertijd wijziging is doorgevoerd.',
			})
		},
	},
}
</script>
